import { Component,OnInit,OnDestroy,AfterViewInit } from '@angular/core';
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { takeWhile } from "rxjs/operators";
import { format,parse,differenceInDays } from 'date-fns';
import addDays from 'date-fns/addDays';
import * as c3 from 'c3';

import {
    PagingInfo
} from "src/app/shared/vo";
import {
    FilterDateDiff
    ,FilterDist
    ,FilterSecToTime
} from "src/app/shared/filter";
import {
    FvmsUtilService
    ,FvmsCommonService
    ,FvmsApiDtgDriveSafeEcoService
    ,FvmsExcelService
    ,FvmsApiAuthService
} from "src/app/shared/service";

//Deprecated
@Component({
    templateUrl: './dtg.analytics.drive.safe.eco.component.html'
    ,styleUrls: ["./dtg.analytics.drive.safe.eco.component.scss"]
    ,providers: [FilterDateDiff,FilterDist,FilterSecToTime]
})
export class DtgAnalyticsDriveSafeEcoComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    dateInfo:any;
    companyInfo:any;
    currentUserInfo:any;
    userGroupId:number;
    dtgTeamId:string = "";
    pagingInfo:PagingInfo = new PagingInfo();
    excelPagingInfo:PagingInfo = new PagingInfo();
    dayDiff:number = 1;
    listItem:any[] = [];
    listYear:number[] = [];
    listMonth:number[] = [];
    dtgUnitId:string = "";
    selectedYear:number = 2020;
    selectedMonth:number = 0;
    selectedDate:any;
    searchValue:string = "";
    selectedRow:number = -1;

    chartColors:any[] = ['#4fc3f7', '#fb8c00', '#7460ee', '#f62d51', '#20c997', '#2962FF', '#40c4ff', '#2961ff', '#ff821c', '#7e74fb'];
    chart01:any;
    chart02:any;
    sumData:any;

    constructor(
        private modalService: NgbModal
        ,private fvmsUtilService: FvmsUtilService
        ,private filterDateDiff:FilterDateDiff
        ,private filterSecToTime:FilterSecToTime
        ,private fvmsCommonService: FvmsCommonService
        ,private fvmsExcelService:FvmsExcelService
        ,private filterDist:FilterDist
        ,private fvmsApiDtgDriveSafeEcoService:FvmsApiDtgDriveSafeEcoService
        ,private fvmsApiAuthService:FvmsApiAuthService
    ) {
        this.currentUserInfo = this.fvmsApiAuthService.getLoginUserInfo();
        this.userGroupId = parseInt(this.currentUserInfo.userGroupId);
        if(this.userGroupId > 100){
            this.dtgTeamId = this.currentUserInfo.teamId;
        }
        this.companyInfo = this.fvmsCommonService.getCompanyInfo();
        let dateTimeInfo = this.fvmsCommonService.getDateInfo();
        this.excelPagingInfo.pageSize = 60*60*24;

        for(let a=2020;a<2100;a++){
            this.listYear.push(a);
        }
        for(let a=1;a<13;a++){
            this.listMonth.push(a);
        }

        let tmpDateInfo = this.fvmsCommonService.getDateInfo();
        if(tmpDateInfo && tmpDateInfo.fromDate){
            this.selectedYear = tmpDateInfo.fromDate.year;
            this.selectedMonth = tmpDateInfo.fromDate.month;
        }else{
            let today = new Date();
            this.selectedYear = today.getFullYear();
            this.selectedMonth = today.getMonth() + 1;
        }

        this.fvmsCommonService.subscribeCompanyInfo()
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(companyInfo => {
                this.companyInfo = companyInfo;
                this.changeDate();
                this.reloadListItem();
                this.reloadListSum();
            });
    }

    ngOnInit() {
        this.changeDate();
        this.initChart01();
        this.reloadListItem();
        this.reloadListSum();
    }

    ngOnDestroy() {
        this.isContinue = false;
    }

    ngAfterViewInit() {}

    getSearchInfo(){
        let dtFrom = new Date(this.selectedYear,this.selectedMonth - 1,1,0,0,0,0);
        let dtTo = new Date(this.selectedYear,this.selectedMonth,1,0,0,0,0);
        dtTo = addDays(dtTo,-1);
        let searchDateFrom = format(dtFrom,"yyyy-MM-dd 00:00:00");
        let searchDateTo = format(dtTo,"yyyy-MM-dd 23:59:59");
        let searchInfo = {
            companyId:this.companyInfo?.companyId || 0
            ,dtgTeamId:this.currentUserInfo?.teamId || ""
            ,searchDateFrom:searchDateFrom
            ,searchDateTo:searchDateTo
            ,searchValue:this.searchValue
            ,dtgGroupByUnitId:"Y"
        };
        return searchInfo;
    }

    reloadListItem(){
        this.fvmsCommonService.setIsLoading(true);
        this.fvmsApiDtgDriveSafeEcoService.getListReportSafeDriving(this.getSearchInfo(),this.pagingInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                this.listItem =[];
                this.selectedRow = -1;
                if(apiResponse.resultStatus === "ok"){
                    if(apiResponse.resultValue){
                        this.listItem = apiResponse.resultValue;
                    }
                    this.pagingInfo = apiResponse.pagingInfo;
                }
                this.fvmsCommonService.setIsLoading(false);
            });
    }

    reloadListSum(){
        let dtFrom = new Date(this.selectedYear,this.selectedMonth - 1,1,0,0,0,0);
        let dtTo = new Date(this.selectedYear,this.selectedMonth,1,0,0,0,0);
        dtTo = addDays(dtTo,-1);
        let searchDateFrom = format(dtFrom,"yyyy-MM-dd 00:00:00");
        let searchDateTo = format(dtTo,"yyyy-MM-dd 23:59:59");
        let searchInfo = {
            companyId:this.companyInfo?.companyId || 0
            ,dtgTeamId:this.currentUserInfo?.teamId || ""
            ,searchDateFrom:searchDateFrom
            ,searchDateTo:searchDateTo
            ,searchValue:this.searchValue
        };
        this.fvmsCommonService.setIsLoading(true);
        this.fvmsApiDtgDriveSafeEcoService.getListReportSafeDriving(searchInfo,this.pagingInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    if(apiResponse.resultValue){
                        this.sumData = apiResponse.resultValue[0];
                        let dtFrom = parse(this.sumData.dtgRegDtFrom,"yyyy-MM-dd HH:mm:ss",new Date());
                        let dtTo = parse(this.sumData.dtgRegDtTo,"yyyy-MM-dd HH:mm:ss",new Date());
                        let diffDay = differenceInDays(dtTo,dtFrom) + 1;
                        // console.log("diffday",diffDay);
                        this.sumData.diffDay = diffDay;
                        this.sumData.avgRule101 = (this.sumData.cntRule101 / this.sumData.dtgDriveCarCnt);
                        this.sumData.avgRule1 = (this.sumData.cntRule1 / this.sumData.dtgDriveCarCnt);
                        this.sumData.avgRule3 = (this.sumData.cntRule3 / this.sumData.dtgDriveCarCnt);
                        this.sumData.avgRule5 = (this.sumData.cntRule5 / this.sumData.dtgDriveCarCnt);
                        this.sumData.avgRule102 = (this.sumData.cntRule102 / this.sumData.dtgDriveCarCnt);
                        this.loadChart01Data(-1);
                    }
                }
                this.fvmsCommonService.setIsLoading(false);
            });
    }

    clickSearch(){
        this.pagingInfo.curPage = 1;
        this.reloadListItem();
        this.reloadListSum();
    }

    changeDate(){
        let dtFrom = new Date(this.selectedYear,this.selectedMonth - 1,1,0,0,0,0);
        let dtTo = new Date(this.selectedYear,this.selectedMonth,1,0,0,0,0);
        dtTo = addDays(dtTo,-1);
        let searchDateFrom = format(dtFrom,"yyyy-MM-dd 00:00:00");
        let searchDateTo = format(dtTo,"yyyy-MM-dd 23:59:59");
        this.selectedDate = {
            searchDateFrom:searchDateFrom
            ,searchDateTo:searchDateTo
        };
    }

    changeYear(e){
        this.changeDate();
        this.clickSearch();
    }

    changeMonth(e){
        this.changeDate();
        this.clickSearch();
    }

    //검색어 입력란에 엔터키 누르면 실행
    keyupEnterSearchValue(e){
        this.changeDate();
        this.clickSearch();
    }

    callbackClickPageNumber(selectedPage:number){
        this.pagingInfo.curPage = selectedPage;
        this.reloadListItem();
    }

    callbackChangeCountRowPerPage(pageSize:number){
        this.pagingInfo.pageSize = pageSize;
        this.reloadListItem();
    }

    selectRow(idx:number = -1){
        if(this.selectedRow !== idx){
            this.selectedRow = idx;
        }else{
            this.selectedRow = -1;
        }
        this.loadChart01Data(this.selectedRow);
    }

    initChart01(){
        let self = this;
        this.chart01 = c3.generate({
            bindto: '#chart-01'
            ,data: {
                columns:[

                ]
                ,type:"bar"
                ,types:{
                    "합계":"line"
                }
                ,onclick:(d,el) => {
                    console.log("click",d.id,d.value);
                }
                ,onmouseover:(d) => {
                }
            }
            ,axis:{
                x:{
                    type:"category"
                    ,categories:[
                        "공회전"
                        ,"과속"
                        ,"급가속"
                        ,"급감속"
                        ,"공회전+고RPM"
                    ]
                }
            }
            ,bar: {

            }
            ,tooltip:{
                // format:{
                //     name:function(name, ratio, id, idx){
                //         // console.log("tooltip",name, ratio, id, idx);
                //         return self.listCarUseCnt[idx].name;
                //     }
                // }
            }
            ,legend: {
                hide: true
            }
            // ,color: {
            //     pattern: self.chartColors
            // }
        });
    }

    loadChart01Data(idx:number = -1){
        if(this.listItem){
            let listSize = this.listItem.length;
            let itemChart01;
            let itemChart01Sum;
            let listChartData = [];

            itemChart01Sum = JSON.parse(JSON.stringify(this.sumData));

            listChartData.push([
                "합계"
                ,itemChart01Sum.cntRule101
                ,itemChart01Sum.cntRule1
                ,itemChart01Sum.cntRule3
                ,itemChart01Sum.cntRule5
                ,itemChart01Sum.cntRule102
            ]);
            listChartData.push([
                "평균"
                ,itemChart01Sum.avgRule101
                ,itemChart01Sum.avgRule1
                ,itemChart01Sum.avgRule3
                ,itemChart01Sum.avgRule5
                ,itemChart01Sum.avgRule102
            ]);

            if(idx > -1){
                let item = this.listItem[idx];
                itemChart01 = JSON.parse(JSON.stringify(item));
                listChartData.push([
                    itemChart01.dtgCarNo
                    ,itemChart01.cntRule101
                    ,itemChart01.cntRule1
                    ,itemChart01.cntRule3
                    ,itemChart01.cntRule5
                    ,itemChart01.cntRule102
                ]);
            }

            this.chart01.load({
                columns:listChartData
                ,unload: true
            });
        }
    }

    excelDownload(){
        this.fvmsCommonService.setIsLoading(true);
        this.fvmsApiDtgDriveSafeEcoService.getListReportSafeDriving(this.getSearchInfo(),this.pagingInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                // this.listItem =[];
                // this.selectedRow = -1;
                if(apiResponse.resultStatus === "ok"){
                    if(apiResponse.resultValue){
                        this.fvmsExcelService.excelDownload(this.convertExcelJson(apiResponse.resultValue),"analytics-drive-safe-eco");
                    }
                    this.pagingInfo = apiResponse.pagingInfo;
                }
                this.fvmsCommonService.setIsLoading(false);
            });
    }

    convertExcelJson(dataList:any[]){
        let resultList = [];
        dataList.map((v) => {
            console.log(v);
            resultList.push({
                "차량번호":v.dtgCarNo
                ,"운전자":v.userId
                ,"운행시간":this.filterSecToTime.transform(v.dtgRegDtDuration,"HH:mm:ss")
                ,"운행거리(km)":this.filterDist.transform(Number(v.dtgDistAccumul))
                ,"과속":v.cntRule1
                ,"장기과속":v.cntRule2
                ,"급가속":v.cntRule3
                ,"급출발":v.cntRule4
                ,"급감속":v.cntRule5
                ,"급정지":v.cntRule6
                ,"급진로변경":v.cntRule7
                ,"급앞지르기":v.cntRule8
                ,"급좌우회전":v.cntRule9
                ,"급U턴":v.cntRule10
                ,"공회전":this.filterSecToTime.transform(v.durRule101,"HH:mm:ss")
                ,"공회전+고RPM":this.filterSecToTime.transform(v.durRule102,"HH:mm:ss")
            })
        });
        return resultList;
    }
}
